import { render } from "./foot.vue?vue&type=template&id=73da9cb9&scoped=true"
const script = {}

import "./foot.vue?vue&type=style&index=0&id=73da9cb9&lang=scss&scoped=true"

import exportComponent from "/Users/a123/Desktop/代码/易考通相关项目/证书查询/zs-query/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73da9cb9"]])

export default __exports__